import { render, staticRenderFns } from "./ComponentTasksTable.vue?vue&type=template&id=5d44af0f&scoped=true"
import script from "./ComponentTasksTable.vue?vue&type=script&lang=js"
export * from "./ComponentTasksTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d44af0f",
  null
  
)

export default component.exports